import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  useTheme,
  Snackbar,
  Alert,
  GlobalStyles,
  IconButton,
  InputAdornment

} from "@mui/material";
import { tokens } from "../components/Theme";
import useMediaQuery from "@mui/material/useMediaQuery";
import bglogin from "../img/login-bg.jpg";
import FetchLogin from "../api/user/SignIn.js";
import { useNavigate } from "react-router-dom";
import logof from "../img/logo-f.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";
const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => setShowPassword((prev) => !prev);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [loading, setLoading] = useState(false);
  const [failedLogin, setFailedLogin] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [formData, setFormData] = useState({
    mobileNo_or_idCard: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLogin = async () => {
    const { mobileNo_or_idCard, password } = formData;
    if (!mobileNo_or_idCard.trim() || !password.trim()) {
      setSnackbarSeverity("warning");
      setSnackbarMessage("กรุณากรอกเลขบัตรประชาชน/เบอร์โทร และรหัสผ่านให้ครบถ้วน");
      setOpenSnackbar(true);
      return; 
    }
    setLoading(true);
    const response = await FetchLogin(formData);
    if (response === 200) {
      const userData = JSON.parse(localStorage.getItem("userdata"));
      setFailedLogin(false);
      setSnackbarSeverity("success");
      setSnackbarMessage("เข้าสู่ระบบสำเร็จ");
      setOpenSnackbar(true);
      if (userData.registor === 1) {
        setTimeout(() => {
          navigate("/home");
        }, 1000);
      } else {
        setTimeout(() => {
          navigate("/farmerInfo");
        }, 1000);
      }
    } else {
      setFailedLogin(true);
      setSnackbarSeverity("error");
      setSnackbarMessage("เข้าสู่ระบบไม่สำเร็จ กรุณาตรวจสอบข้อมูลอีกครั้ง");
      setOpenSnackbar(true);
      setFormData({ mobileNo_or_idCard: "", password: "" });
    }

    setLoading(false);
  };

  return (
    <>
      <GlobalStyles
        styles={{
          html: { margin: 0, padding: 0, overflow: "hidden", height: "100%" },
          body: { margin: 0, padding: 0, overflow: "hidden", height: "108%" },
        }}
      />
      <Box
        sx={{
          position: "relative",
          minHeight: "100vh",
          display: "flex",
          justifyContent: isMobile ? "center" : "flex-end",
          alignItems: "center",
          px: isMobile ? 2 : 0,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: isMobile ? "100%" : "100vh",
            backgroundImage: `url(${bglogin})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 0.7,
            zIndex: 0,
          }}
        />
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            textAlign: "center",
            height: isMobile ? "100%" : "100vh",
            backgroundColor: isMobile
              ? "rgba(255, 255, 255, 0.95)"
              : "rgba(255, 255, 255, 1)",
            p: isMobile ? 3 : 5,
            borderRadius: 2,
            width: isMobile ? "90%" : "50%",
          }}
        >
          <img src={logof} width={isMobile ? "120px" : "200px"} alt="logo" />
          <Typography
            fontWeight="bold"
            variant={isMobile ? "h6" : "h4"}
            mt={isMobile ? 2 : 5}
          ></Typography>
          <Box textAlign="start" mt={isMobile ? 3 : 5}>
            <Typography>เลขบัตรประชาชน หรือ เบอร์โทรศัพท์</Typography>
            <TextField
              fullWidth
              name="mobileNo_or_idCard"
              value={formData.mobileNo_or_idCard}
              onChange={handleChange}
              label="เลขบัตรประชาชน หรือ เบอร์โทรศัพท์"
              variant="filled"
              margin="normal"
            />
          </Box>
          <Box textAlign="start" mt={3}>
  <Typography>
    รหัสผ่าน{" "}
    <Button
      onClick={() => navigate("/forgetpassword")}
      disabled={loading}
      variant="text"
      sx={{
        textDecoration: "underline",
        color: "primary.main",
        fontSize: "0.85rem",
        padding: 0,
        minWidth: "auto",
        verticalAlign: "baseline",
        "&:hover": {
          backgroundColor: "transparent",
        },
      }}
    >
      *ลืมรหัสผ่าน?
    </Button>
  </Typography>
  <TextField
      fullWidth
      name="password"
      value={formData.password}
      onChange={handleChange}
      label="รหัสผ่าน"
      type={showPassword ? "text" : "password"}
      variant="filled"
      margin="normal"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={togglePassword} edge="end">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
</Box>

          
          <Button
            variant="contained"
            fullWidth
            sx={{
              mt: isMobile ? 3 : 5,
              backgroundColor: colors.greenAccent[400],
              borderRadius: "20px",
            }}
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? "กำลังเข้าสู่ระบบ..." : "เข้าสู่ระบบ"}
          </Button>
          <Button
            variant="text"
            fullWidth
            sx={{
              mt: isMobile ? 2 : 2,
              textDecoration: "underline",
              color: "primary.main", 
              "&:hover": {
                backgroundColor: "transparent", 
                textDecoration: "underline", 
              },
              padding: 0,
              minWidth: "auto", 
            }}
            onClick={()=>navigate("/register")}
            disabled={loading}
          >
            สมัครสมาชิก
          </Button>

          <Button
  variant="text"
  fullWidth
  sx={{
    mt: isMobile ? 1 : 1,
    textDecoration: "underline",
    color: "primary.main",
    "&:hover": {
      backgroundColor: "transparent",
      textDecoration: "underline",
    },
    padding: 0,
    minWidth: "auto",
  }}
  component="a"
  href="https://lin.ee/DmW6sJb"
  target="_blank"
  rel="noopener noreferrer"
  disabled={loading}
>
  ติดต่อเรา
</Button>
        </Box>
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarSeverity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Login;
